













































































import moment from "moment";
import { Component, Vue, Ref, Prop } from "vue-property-decorator";
const columns = []
export default Vue.extend({
  data(){
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      form: this.$form.createForm(this)
    }
  },
  props:{
    employeesList:{
      type: Array,
      default: () => ([])
    },
    editData:{
      type: Object,
      default: () => ({})
    }
  },
  methods:{
    moment,
    disabledDate(current) {
      return current && current < moment().endOf('day');
    },
  }
})

